import { REFRESH_TOKEN } from "./refreshToken"
import { client } from "../../lib/graphql"

export const getNewToken = async () => {
  return await client.query({
    query: REFRESH_TOKEN
  });
};

